var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefresh = function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1F1F1F",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "M13.073 5.038c-2.298-.514-4.424.206-6.376 2.159a7.5 7.5 0 0 0 0 10.606m4.225 2.158c2.301.514 4.429-.205 6.381-2.158a7.5 7.5 0 0 0 0-10.606M3.75 18.393h3.536l.048-3.607M20.25 6.607h-3.536l-.115 3.725",
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgRefresh as ReactComponent };
export default __webpack_public_path__ + "85c7e6b744b7bbd0a4c66a92435428d9.svg";